/**
 * View component for /nodes
 *
 * Generic node list view. Defaults to 'all' with:
 * this.props.dispatch(nodeActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as nodeActions from '../nodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import node components
import NodeLayout from '../components/NodeLayout.js.jsx';
import NodeListItem from '../components/NodeListItem.js.jsx';

// import node css modules
import nodeStyles from '../nodeModuleStyles.css';

class NodeList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch a list of your choice
    this.props.dispatch(nodeActions.fetchListIfNeeded()); // defaults to 'all'
  }

  render() {
    const { nodeStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */

    // get the nodeList meta info here so we can reference 'isFetching'
    const nodeList = nodeStore.lists ? nodeStore.lists.all : null;

    /**
     * use the reducer getList utility to convert the all.items array of ids
     * to the actual node objetcs
     */
    const nodeListItems = nodeStore.util.getList("all");

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !nodeListItems || !nodeList || nodeListItems.length === 0;

    return (
      <NodeLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Node List
                <Link className="yt-btn small u-pullRight" to={'/nodes/new'}> NEW Node </Link>
              </h1>
              <hr/>
              { isEmpty ?
                  (nodeListItems && nodeList && nodeList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                  <div style={{ opacity: nodeList.isFetching ? 0.5 : 1 }}>
                    <ul>
                      {nodeListItems.map((node, i) =>
                        <NodeListItem key={node._id} node={node} />
                      )}
                    </ul>
                  </div>
              }
            </div>
          </section>
        </div>
      </NodeLayout>
    )
  }
}

NodeList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    nodeStore: store.node
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(NodeList)
);



// WEBPACK FOOTER //
// modules/node/views/NodeList.js.jsx